export default "__VITE_ASSET__DXk63atU__"